
import React from "react";


export default function PrevTooltip({ active, payload, label,baseline }) {
  if (active && payload?.length) {
    return (
      <div
        style={{
          backgroundColor: "#f5f5f5",
          border: "1px solid #ccc",
          borderRadius: "8px",
          padding: "10px 14px",
          fontSize: "14px",
          fontWeight: "bold",
          color: "#333",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        {/* Title */}
        <div
          style={{
            borderBottom: "1px solid #ddd",
            marginBottom: "6px",
            paddingBottom: "4px",
          }}
        >
          {label}
        </div>

        {/* Values */}
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {payload.map((item, idx) => {
            const value = item.value;
            const aboveBaseline = value >= baseline;
            const color = aboveBaseline ? "red" : "green";

            return (
              <li
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "4px",
                }}
              >
                <div
                  style={{
                    width: 10,
                    height: 10,
                    backgroundColor: color,
                    marginRight: 8,
                    borderRadius: "50%",
                  }}
                />
                <span style={{ color: "#555", fontWeight: "normal" }}>
                  {item.name}:
                </span>
                <span style={{ marginLeft: 4, color: "#000" }}>
                  {value?.toLocaleString()}
                </span>
                <span
                  style={{
                    marginLeft: 6,
                    fontSize: "12px",
                    color: "#666",
                    fontStyle: "italic",
                  }}
                >
                  ({aboveBaseline ? "Above baseline" : "Below baseline"})
                </span>
              </li>
            );
          })}

          {/* Baseline row */}
          <li
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "6px",
              borderTop: "1px solid #ddd",
              paddingTop: "4px",
            }}
          >
            <div
              style={{
                width: 10,
                height: 2,
                backgroundColor: "black",
                marginRight: 8,
              }}
            />
            <span style={{ color: "#555", fontWeight: "normal" }}>
              Baseline:
            </span>
            <span style={{ marginLeft: 4, color: "#000" }}>{baseline}</span>
          </li>
        </ul>
      </div>
    );
  }
  return null;
}
